import React from 'react';
import envConfig from '../../../config/env';
/**
 * 20210126 自動職缺零筆 也不顯示
 */
class CompanyJobs extends React.Component {

    constructor(props){
        super(props);
        this.state={};
    }

    componentDidMount(){
        const cid = this.props.match.params.cid;
        this.props.getPositionList(cid, this.props.themeNum);
        this.props.getPositionGrpList(cid, this.props.themeNum);
        this.props.getkind00(cid);
    }

    render(){       
        
        const { positionGrpData } = this.props.positionGrpReducer;
        const { positionData } = this.props.positionReducer;
        const { kind00Data } = this.props.kind00Reducer;
        
        let isAutoPosition=0;//add 20201207
		let positionURL2 = "https://www.1111.com.tw/job/";
        let owlLists = [];
		const limitCount=envConfig.PositionCount;

        if(positionGrpData && positionGrpData.length > 0){
            positionGrpData.forEach( element  => {
            isAutoPosition=element.position_IsAuto;
            })     
        }
        //console.log('type'+typeof(kind00Data)+'data00'+ kind00Data);
        if(isAutoPosition===0){
            Array.isArray(positionData) && positionData.filter( data => data.position_group === "1").forEach((element, index) => {
                let positionURL = positionURL2+ element.eNo + "/";
                owlLists.push(
                    <div key={index} className="single-services-box">
                         <div className="icon">
                            <i className="flaticon-team"></i>
                        </div>

                        <h3 className="card_height"><a href={positionURL} target="_blank" rel="noopener noreferrer">{element.position_name}</a></h3>

                        <p className="salary-fmt">{element.position_salary}</p>
                        <p>{element.position_workCity}</p>                                
                        <a target="_blank" rel="noopener noreferrer" href={positionURL} className="default-btn tp05_position_btn tp05_hover-btn">我要應徵</a>

                        <div className="box-shape">
                            <img src="../../../assets/tp05/img/box-shape1.png" alt="熱門職缺" />
                             <img src="../../../assets/tp05/img/box-shape1g.png" alt="熱門職缺" />
                        </div>
                    </div>
                )
            })
        }
        else if (isAutoPosition===1){
            Array.isArray(kind00Data) && kind00Data.forEach((element, index) => {
                let positionURL = positionURL2+ element.eNo + "/";
                if(index < limitCount){
                    owlLists.push(
                        <div key={index} className="single-services-box">
                            <div className="icon">
                                <i className="flaticon-team"></i>
                            </div>
                            <h3 className="card_height"><a href={positionURL} target="_blank" rel="noopener noreferrer">{element.Position}</a></h3>
                            <p className="salary-fmt">{element.Salary}</p>
                            <p>{element.WorkCity}</p>                                
                            <a target="_blank" rel="noopener noreferrer" href={positionURL} className="default-btn tp05_position_btn tp05_hover-btn">我要應徵</a>
                            <div className="box-shape">
                                <img src="../../../assets/tp05/img/box-shape1.png" alt="熱門職缺" />
                                <img src="../../../assets/tp05/img/box-shape1g.png" alt="熱門職缺" />
                            </div>
                        </div>
                    )
                }
            })
        }

        return (
            <section className="services-area bg-f8f8f8 pb-50 pt-70" 
                     style={((isAutoPosition===0 && positionData.length <= 0) 
                     || (isAutoPosition===1 && (kind00Data.length <= 0 || (kind00Data.length===1 && kind00Data[0].oNo===0)))
                     ) ? {display: 'none'} :{}}>
            <style>
              {((isAutoPosition===0 && positionData.length <= 0) 
              || (isAutoPosition===1 && (kind00Data.length <= 0 || (kind00Data.length===1 && kind00Data[0].oNo===0)))
              ) && `.job-display {display:none !important;}`}
            </style>     
            <div id="jobs" className="container">
                    <div className="section-title">
                    <span className="sub-title">Jobs</span>
                        <h2>熱門職缺</h2>
    
                    </div>
                    <div className="services-slides owl-carousel owl-theme">
                        {owlLists}
                        {/* {Array.isArray(positionData) && positionData.filter( data => data.position_group === "1").map((element, index) => {
                            let positionURL = "https://www.1111.com.tw/job/"+ element.eNo + "/";
                                                    
                            return(

                                <div key={index} className="single-services-box">
                                    <div className="icon">
                                        <i className="flaticon-team"></i>

                                    </div>

                                    <h3 className="card_height"><a href={positionURL} target="_blank" rel="noopener noreferrer">{element.position_name}</a></h3>

                                    <p className="salary-fmt">{element.position_salary}</p>
                                    <p>{element.position_workCity}</p>
                                
                                    <a target="_blank" rel="noopener noreferrer" href={positionURL} className="default-btn tp05_position_btn tp05_hover-btn">我要應徵</a>

                                    <div className="box-shape">
                                        <img src="../../../assets/tp05/img/box-shape1.png" alt="熱門職缺" />
                                        <img src="../../../assets/tp05/img/box-shape1g.png" alt="熱門職缺" />
                                    </div>
                                </div>
                                
                            )

                        })} */}

                    </div>
                </div>
            </section>
        )

    }
}

export default CompanyJobs;